import axiosPost from "../axiosPost"

export const SFLoteVoucherGet = async (params = {}, credentials) => {
    const body = {
        service: "SFLoteVoucherGet",
        params: {
            SFVoucherTipo: params?.SFVoucherTipo,
            usuarioNroDeDocumentoX: params?.usuarioNroDeDocumentoX,
            SFVoucherFecha: params?.SFVoucherFecha,
            page: params?.page ?? null,
            pageSize: params?.pageSize ?? null,
        },
    };

    const response = await axiosPost(body, credentials);

    return {
        result: response.result,
        total: response.status?.id ?? response.result?.length ?? 0,
    };
}
